import { formatDate } from '@ui/src';
import { SystemLogsTypes } from './types';

import cn from './styles.module.css';

const SystemLogs = ({ systemLogs }: SystemLogsTypes) => (
  <div>
    {systemLogs?.map((item) => (
      <div className={cn.systemLogWrapper} key={item.id}>
        <div className={cn.systemLogValues}>
          <div className={cn.systemLogWrapperLeft}>
            <div className={cn.systemLogRow}>
              Entity:
              <span>{item.entity}</span>
            </div>
            <div className={cn.systemLogRow}>
              Status:
              <span className={cn.systemLogRowValue}>{item.status}</span>
            </div>
            {item.additionalInformation && (
              <div className={cn.systemLogAdditionInfo}>
                {item.additionalInformation}
              </div>
            )}
          </div>
          <div className={cn.systemLogWrapperRight}>
            {formatDate(item.createdAt, true)}
          </div>
        </div>
        <div className={cn.systemLogRow}>
          {item.error && (
            <span
              className={`${cn.systemLogRowValue} ${cn.systemLogRowValueError}`}
            >
              <pre>
                {JSON.stringify(
                  item.error.includes('{') && item.error.charAt(0) === '{'
                    ? JSON.parse(item.error)
                    : item.error,
                  null,
                  2,
                )}
              </pre>
            </span>
          )}
        </div>
      </div>
    ))}
  </div>
);

export default SystemLogs;
